"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppPrice = exports.AppInstalls = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("HubStyleTokens/colors");

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIIconCircle = _interopRequireDefault(require("UIComponents/icon/UIIconCircle"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var CustomRenderer = _interopRequireWildcard(require("UIComponents/utils/propTypes/customRenderer"));

var PlanType = _interopRequireWildcard(require("../../constants/pricings/PlanType"));

var _planType = _interopRequireDefault(require("../../constants/propTypes/planType"));

var _RatingTypes = require("../../constants/reviews/RatingTypes");

var Collection = _interopRequireWildcard(require("../../constants/search/Collection"));

var _currency = require("../../utils/currency");

var _offerings = require("../../utils/offerings");

var _PieSynConnectorIcon = _interopRequireDefault(require("../common/PieSynConnectorIcon"));

var _Rating = _interopRequireDefault(require("../reviews/Rating"));

var _AbstractCard = _interopRequireDefault(require("./AbstractCard"));

var _Footer = _interopRequireDefault(require("./Footer"));

var _Price = _interopRequireDefault(require("./Price"));

var getI18nKey = function getI18nKey(key) {
  return "ecosystemMarketplaceCore.cards.appCard." + key;
};

var AppInstalls = function AppInstalls(_ref) {
  var activeCollection = _ref.activeCollection,
      firstPublishedAt = _ref.firstPublishedAt,
      hubInstalls = _ref.hubInstalls,
      installed = _ref.installed,
      isPieSyncConnector = _ref.isPieSyncConnector,
      isUngatedForRemovePieSyncConnectorInstallCount = _ref.isUngatedForRemovePieSyncConnectorInstallCount;

  if (isPieSyncConnector && isUngatedForRemovePieSyncConnectorInstallCount) {
    return null;
  }

  if (installed) {
    return _react.default.createElement("span", {
      className: "align-baseline"
    }, _react.default.createElement(_UIIconCircle.default, {
      className: "m-right-2",
      color: _colors.OLAF,
      backgroundColor: _colors.OZ,
      name: "success",
      padding: 0.2,
      size: 9
    }), _react.default.createElement(_Small.default, {
      use: "help"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('installs.installed')
    })));
  }

  var isNewOffering = (0, _offerings.getIsNewOffering)(firstPublishedAt);
  var installsBucket = (0, _offerings.getInstallsBucket)(hubInstalls);
  var renderedMessage;

  if (activeCollection === Collection.NEW || isNewOffering && activeCollection !== Collection.POPULAR) {
    renderedMessage = _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('installs.new')
    });
  } else if (installsBucket) {
    renderedMessage = _react.default.createElement(_FormattedJSXMessage.default, {
      message: getI18nKey('installs.bucket_jsx'),
      options: {
        value: installsBucket
      },
      elements: {
        Number: _FormattedNumber.default
      }
    });
  } else {
    renderedMessage = _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('installs.min')
    });
  }

  return _react.default.createElement(_Small.default, {
    use: "help"
  }, renderedMessage);
};

exports.AppInstalls = AppInstalls;

var AppPrice = function AppPrice(_ref2) {
  var minCents = _ref2.minCents,
      minCommitmentCents = _ref2.minCommitmentCents,
      minPlanType = _ref2.minPlanType,
      pricingsCount = _ref2.pricingsCount,
      showCommitmentPrice = _ref2.showCommitmentPrice;

  if (minCents == null) {
    return null;
  }

  if (minPlanType === PlanType.FREE) {
    return _react.default.createElement(_Price.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('planType.free')
    }));
  }

  var planTypeI18nKey;
  var value = minCents;

  if (minPlanType === PlanType.MONTHLY) {
    planTypeI18nKey = 'monthly_jsx';

    if (minCommitmentCents && showCommitmentPrice) {
      var commitmentCents = minCommitmentCents / 12;
      value = commitmentCents < minCents ? commitmentCents : minCents;
    }
  } else if (minPlanType === PlanType.YEARLY) {
    planTypeI18nKey = 'yearly_jsx';
  } else if (minPlanType === PlanType.ONE_TIME) {
    planTypeI18nKey = 'oneTime_jsx';
  } else {
    return null;
  }

  var renderedPrice = _react.default.createElement(_FormattedJSXMessage.default, {
    message: getI18nKey("planType." + planTypeI18nKey),
    elements: {
      Price: _Price.default,
      Small: _Small.default
    },
    options: {
      value: (0, _currency.formatCentsToDollars)(value)
    }
  });

  if (pricingsCount > 1) {
    return _react.default.createElement("div", null, _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('startingAt')
    })), ' ', renderedPrice);
  }

  return renderedPrice;
};

exports.AppPrice = AppPrice;

var AppCard = function AppCard(props) {
  var activeCollection = props.activeCollection,
      companyName = props.companyName,
      firstPublishedAt = props.firstPublishedAt,
      hubInstalls = props.hubInstalls,
      iconUrl = props.iconUrl,
      installed = props.installed,
      isUngatedForRemovePieSyncConnectorInstallCount = props.isUngatedForRemovePieSyncConnectorInstallCount,
      minCents = props.minCents,
      minCommitmentCents = props.minCommitmentCents,
      minPlanType = props.minPlanType,
      name = props.name,
      nativeId = props.nativeId,
      offeringId = props.offeringId,
      PieSyncConnectorIcon = props.pieSyncConnectorIconComponent,
      pricingsCount = props.pricingsCount,
      reviewSummary = props.reviewSummary,
      showCommitmentPrice = props.showCommitmentPrice,
      tagline = props.tagline,
      rest = (0, _objectWithoutProperties2.default)(props, ["activeCollection", "companyName", "firstPublishedAt", "hubInstalls", "iconUrl", "installed", "isUngatedForRemovePieSyncConnectorInstallCount", "minCents", "minCommitmentCents", "minPlanType", "name", "nativeId", "offeringId", "pieSyncConnectorIconComponent", "pricingsCount", "reviewSummary", "showCommitmentPrice", "tagline"]);
  var isPieSyncConnector = (0, _offerings.getIsPieSyncConnector)(nativeId, offeringId);
  var renderedCompanyName = (0, _react.useMemo)(function () {
    if (companyName) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('companyName'),
        options: {
          companyName: companyName
        }
      });
    }

    return null;
  }, [companyName]);
  var renderStatus = (0, _react.useCallback)(function () {
    if (isPieSyncConnector) {
      return _react.default.createElement(PieSyncConnectorIcon, {
        className: "m-right-0"
      });
    }

    return null;
  }, [isPieSyncConnector]);
  var renderBody = (0, _react.useCallback)(function () {
    if (!reviewSummary || reviewSummary.reviewCount === 0) {
      return null;
    }

    return _react.default.createElement(_UICardSection.default, {
      className: "p-bottom-0 p-top-3"
    }, _react.default.createElement(_Rating.default, {
      rating: reviewSummary.overallRating,
      label: reviewSummary.reviewCount,
      use: "card",
      type: _RatingTypes.STAR_RATING_FILLED
    }));
  }, [reviewSummary]);
  var renderFooter = (0, _react.useCallback)(function () {
    return _react.default.createElement(_Footer.default, null, _react.default.createElement(_UIBox.default, null, _react.default.createElement(AppInstalls, {
      activeCollection: activeCollection,
      firstPublishedAt: firstPublishedAt,
      hubInstalls: hubInstalls,
      installed: installed,
      isPieSyncConnector: isPieSyncConnector,
      isUngatedForRemovePieSyncConnectorInstallCount: isUngatedForRemovePieSyncConnectorInstallCount
    })), _react.default.createElement(_UIBox.default, null, _react.default.createElement(AppPrice, {
      pricingsCount: pricingsCount,
      minPlanType: minPlanType,
      minCents: minCents,
      minCommitmentCents: minCommitmentCents,
      showCommitmentPrice: showCommitmentPrice
    })));
  }, [activeCollection, firstPublishedAt, hubInstalls, installed, isPieSyncConnector, isUngatedForRemovePieSyncConnectorInstallCount, minCents, minCommitmentCents, minPlanType, pricingsCount, showCommitmentPrice]);
  return _react.default.createElement(_AbstractCard.default, (0, _extends2.default)({}, rest, {
    bodyComponent: renderBody,
    footerComponent: renderFooter,
    iconUrl: iconUrl,
    statusComponent: renderStatus,
    subtitle: tagline,
    title: name,
    titleHelpText: renderedCompanyName
  }));
};

AppCard.propTypes = {
  activeCollection: _propTypes.default.string,
  companyName: _propTypes.default.string,
  firstPublishedAt: _propTypes.default.number.isRequired,
  hubInstalls: _propTypes.default.number.isRequired,
  iconUrl: _propTypes.default.string.isRequired,
  installed: _propTypes.default.bool,
  isUngatedForRemovePieSyncConnectorInstallCount: _propTypes.default.bool,
  minCents: _propTypes.default.number,
  minCommitmentCents: _propTypes.default.number,
  minPlanType: _planType.default,
  name: _propTypes.default.string.isRequired,
  nativeId: _propTypes.default.string,
  offeringId: _propTypes.default.number,
  pieSyncConnectorIconComponent: CustomRenderer.propType,
  pricingsCount: _propTypes.default.number,
  reviewSummary: _propTypes.default.shape({
    overallRating: _propTypes.default.number.isRequired,
    reviewCount: _propTypes.default.number.isRequired
  }),
  showCommitmentPrice: _propTypes.default.bool,
  tagline: _propTypes.default.string
};
AppCard.defaultProps = {
  installed: false,
  isUngatedForRemovePieSyncConnectorInstallCount: false,
  nativeId: '0',
  offeringId: 0,
  pieSyncConnectorIconComponent: _PieSynConnectorIcon.default,
  pricingsCount: 0,
  showCommitmentPrice: true,
  tagline: ''
};
var _default = AppCard;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/cards/AppCard.js
// module id = 882
// module chunks = 209 210 211 212